<template>
  <div class="ma-4 app">
    <v-row dense class="mx-2 mb-4" align="start">
      <v-col class="text-left">
        <div class="text-h4">Chamadas</div>
      </v-col>
    </v-row>
    <v-row>
      <v-expansion-panels v-model="panel" multiple focusable>
        <v-expansion-panel readonly>
          <v-expansion-panel-header hide-actions>
            <div class="text-center font-weight-bold">
              <v-row dense>
                <v-col cols="2" class="text-left">Data</v-col>
                <v-col cols="2" class="pl-4 text-left">Origem</v-col>
                <v-col cols="2" class="pl-4 text-left">Destino</v-col>
                <v-col cols="2" class="pl-3 text-left">Status</v-col>
                <v-col cols="2" class="text-left">Tempo Total</v-col>
                <v-col cols="2" class="text-left">Conversação</v-col>
              </v-row>
            </div>
          </v-expansion-panel-header>
        </v-expansion-panel>
        <v-expansion-panel v-for="(item, i) in chamadasRecebidas" :key="i">
          <v-expansion-panel-header ripple>
            <div class="text-center">
              <v-row dense>
                <v-col cols="2">{{ item.data }}</v-col>
                <v-col cols="2" class="text-left pl-5">{{ item.numeroOrigem }}</v-col>
                <v-col cols="2" class="text-left pl-6">{{ item.numeroDestino }}</v-col>
                <v-col cols="2" class="text-left pl-6">{{ statusObject[`${item.status}`] }}</v-col>
                <v-col cols="2" class="text-left pl-6">{{ item.totalChamada }}</v-col>
                <v-col cols="2" class="text-left pl-6">{{ item.conversacaoChamada }}</v-col>
              </v-row>
            </div>
            <template v-slot:actions>
              <v-icon color="orangePcm">$expand</v-icon>
            </template>
          </v-expansion-panel-header>
          <v-expansion-panel-content color="background">
            <v-timeline dense>
              <v-timeline-item small color="orangePcm" fill-dot>
                <v-card color="background">
                  <v-row dense>
                    <v-col cols="12">
                      <v-card-title>{{ titleObject[`${item.status}`] }}</v-card-title>
                    </v-col>
                    <v-col>
                      <v-card-text>
                        <strong>Data: </strong>
                        {{ item.data }}
                      </v-card-text>
                    </v-col>
                    <v-col>
                      <v-card-text>
                        <strong>Origem: </strong>
                        {{ item.numeroOrigem }}
                      </v-card-text>
                    </v-col>
                    <v-col>
                      <v-card-text>
                        <strong>Destino: </strong>
                        {{ item.numeroDestino }}
                      </v-card-text>
                    </v-col>
                    <v-col>
                      <v-card-text>
                        <strong>Ação: </strong>
                        {{ actionObject[`${item.acao}`] }}
                      </v-card-text>
                    </v-col>
                  </v-row>
                  <v-divider class="ma-2" />
                  <v-row align="center" align-content="center" dense v-if ="item.status != 'atendida'">
                    <v-col cols="2">
                      <v-card-text>
                        <strong>{{ item.acao === 'DiscarConferencia' ? 'Conferência: ' : 'Atendente: ' }}</strong>
                        {{ verificaTronco(item.atendente, item.numeroOrigem, item.numeroDestino, item.acao) }}
                      </v-card-text>
                    </v-col>
                    <v-col cols="2">
                      <v-card-text> <strong>Centro de Custo: </strong> {{ item.centroDeCusto }} </v-card-text>
                    </v-col>
                    <v-col cols="2" class="pl-10">
                      <v-card-text> <strong>Status: </strong> {{ statusObject[`${item.status}`] }} </v-card-text>
                    </v-col>
                    <Player
                      v-if="permissaoOuvirAudio"
                      :acao="item.acao"
                      :archive="
                        item.acao === 'DiscarConferencia'
                          ? `${item.atendente}-${item.uniqueidCall}-${item.linkedid}.wav`
                          : item.gravacoes[0]
                      "
                      :file="
                        item.acao === 'DiscarConferencia'
                          ? getAudioConference(`${item.atendente}-${item.uniqueidCall}-${item.linkedid}.wav`)
                          : getAudio(item.gravacoes[0])
                      "
                      downloadable
                      color="primary"
                    />
                    <v-col v-if="item.protocol[0] != undefined " >
                      <v-card-text >
                        <strong>Protocolo: </strong> {{ item.protocol }}
                      </v-card-text>
                    </v-col>
                  </v-row>
                  <v-row align="center" align-content="center" dense v-if ="item.status == 'atendida'">
                    <v-col cols="2">
                      <v-card-text>
                        <strong>{{ item.acao === 'DiscarConferencia' ? 'Conferência: ' : 'Atendente: ' }}</strong>
                        {{ verificaTronco(item.atendente, item.numeroOrigem, item.numeroDestino, item.acao) }}
                      </v-card-text>
                    </v-col>
                    <v-col cols="3">
                      <v-card-text> <strong>Centro de Custo: </strong> {{ item.centroDeCusto }} </v-card-text>
                    </v-col>
                    <v-col cols="3" class = "pl-12">
                      <v-card-text> <strong>Status: </strong> {{ statusObject[`${item.status}`] }} </v-card-text>
                    </v-col>
                    <Player
                      v-if="permissaoOuvirAudio"
                      :acao="item.acao"
                      :archive="
                        item.acao === 'DiscarConferencia'
                          ? `${item.atendente}-${item.uniqueidCall}-${item.linkedid}.wav`
                          : item.gravacoes[0]
                      "
                      :file="
                        item.acao === 'DiscarConferencia'
                          ? getAudioConference(`${item.atendente}-${item.uniqueidCall}-${item.linkedid}.wav`)
                          : getAudio(item.gravacoes[0])
                      "
                      downloadable
                      color="primary"
                    />
                  </v-row>
                </v-card>
              </v-timeline-item>
              <div v-if="item.eventos">
                <div v-for="(evento, key) in item.eventos" :key="key">
                  <TimeLineTransferenciaConf
                    v-if="
                      evento.acao && evento.acao.split('\\')[evento.acao.split('\\').length - 1] === 'DiscarConferencia'
                    "
                    :evento="evento"
                  />
                  <TimeLineEventoTransferencia
                    v-else-if="evento.tipoChamada === 'transferencia'"
                    :evento="evento"
                    :centro-de-custo="item.centroDeCusto"
                  />
                  <TimeLineBlindTransfer
                    v-else-if="evento.tipoChamada === 'BLINDTRANSFER'"
                    :evento="evento"
                    :centro-de-custo="item.centroDeCusto"
                    :numero-origem="item.numeroOrigem"
                    :numero-destino="item.numeroDestino"
                  />
                </div>
              </div>
              <v-timeline-item color="orangePcm" fill-dot small v-if="item.status === 'atendida'">
                <v-card>
                  <v-row dense>
                    <v-col cols="12">
                      <v-card-title>
                        Final Ligação
                      </v-card-title>
                    </v-col>
                  </v-row>
                  <v-row align="center" align-content="center" dense>
                    <v-col>
                      <v-card-text> <strong>Data final: </strong> {{ item.finalChamada }} </v-card-text>
                    </v-col>
                    <v-col>
                      <v-card-text>
                        <strong>Desligado por: </strong>
                        {{ ligacaoCaiu(item.hangupSource, item.numeroDestino) }}
                      </v-card-text>
                    </v-col>
                    <v-col>
                      <v-card-text>
                        <strong>Tempo Total: </strong>
                        {{ item.totalChamada }}
                      </v-card-text>
                    </v-col>
                    <v-col>
                      <v-card-text>
                        <strong>Conversação: </strong>
                        {{ item.conversacaoChamada }}
                      </v-card-text>
                    </v-col>
                    <v-col v-if="item.protocol[0] != undefined">
                      <v-card-text  >
                        <strong>Protocolo: </strong> {{ item.protocol }}
                      </v-card-text>
                    </v-col>
                  </v-row>
                </v-card>
              </v-timeline-item>
            </v-timeline>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-row>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

import { registerVuexModule } from '@/utils/vuexUtils'
import { obtainUserPermissions } from '@/utils/obtainUserPermissions'

import relatorioChamadasStore from '../_store'
import Player from '../_components/Player'
import TimeLineEventoTransferencia from '../_components/TimeLineEventoTransferencia'
import TimeLineBlindTransfer from '../_components/TimeLineBlindTransfer'
import TimeLineTransferenciaConf from '../_components/TimeLineTransferenciaConf'
import { listaRelatorioChamadasMethods } from '../_utils/listaRelatorioChamadasMethods'

export default {
  name: 'ListaRelatorioChamadas',
  props: {
    chamadasRecebidas: Array,
    form: Object,
  },
  components: { Player, TimeLineEventoTransferencia, TimeLineBlindTransfer, TimeLineTransferenciaConf },

  data() {
    return {
      panel: [],
      actionObject: {
        DiscarGrupo: 'Discar para grupo de atendimento',
        DiscarRamal: 'Discar para ramal',
        DiscarTronco: 'Discar para tronco',
        TocarUra: 'Discar para URA',
        TocarSinalDeOcupado: 'Tocar sinal de ocupado',
        TocarAudio: 'Tocar áudio',
        ValidarSenha: 'Validar senha',
        ChangeToTrueActiveRegex: 'Ativar expressão regular',
        ChangeToFalseActiveRegex: 'Desativar expressão regular',
        DiscarFila: 'Discar para fila',
        DiscarAgente: 'Discar para operador',
        DiscarConferencia: 'Discar para conferência',
      },
      statusObject: {
        atendida: 'Atendida',
        ocupado: 'Ocupado',
        acessoNegado: 'Acesso Negado',
        naoAtendida: 'Não Atendida',
        error: 'Erro',
        outros: 'Outros',
        pending: 'Pendente',
      },
      titleObject: {
        atendida: 'Status Atendimento: Atendida',
        ocupado: 'Status Atendimento: Ocupado',
        acessoNegado: 'Status Atendimento: Acesso Negado',
        naoAtendida: 'Status Atendimento: Não Atendida',
        error: 'Status Atendimento: Erro',
        outros: 'Status Atendimento: Outros',
        pending: 'Status Atendimento: Pendente',
      },
      permissaoOuvirAudio: false,
      arrayPermissoesComponenteAudio: [process.env.VUE_APP_ADMINISTRADOR, process.env.VUE_APP_PABX_HABILITADO],
    }
  },

  computed: {
    ...mapGetters('listaRelatorioChamadasModulePABXStore', ['getDescriptionSpecificConferencia']),
  },

  async created() {
    registerVuexModule(this.$store, 'listaRelatorioChamadasModulePABXStore', relatorioChamadasStore)
    const arrayPermissions = this.arrayPermissionsFromLocalStorage()

    arrayPermissions.forEach(permissionFromLocalStorage => {
      if (this.arrayPermissoesComponenteAudio.includes(permissionFromLocalStorage)) {
        this.permissaoOuvirAudio = true
      }
    })
  },

  methods: {
    ...listaRelatorioChamadasMethods,
    ...obtainUserPermissions,
  },
  watch: {
    chamadasRecebidas() {
      this.panel = []
    },
  },
}
</script>

<style scoped>
.app {
  background-color: var(--v-background-base);
}
</style>
